import React, { useState } from 'react';
import { func, shape, string } from 'prop-types';
import DataTypeSelect from '../FormFields/DataTypeSelect';

import classes from './EditableDataTypeFormatter.module.css';

const EditableDataTypeFormatter = ({
    name,
    onChange,
    row,
    ...props
}) => {
    const [value, setValue] = useState(row[name]);

    function handleChange(event) {
        const { name, value: eventValue } = event.target;
        setValue(eventValue);
        onChange(name, eventValue, row);
    }

    return (
        <DataTypeSelect
            className={classes.select}
            name={name}
            onChange={handleChange}
            showLabel={false}
            value={value}
        />);
};

EditableDataTypeFormatter.defaultProps = {
    onChange: () => {},
    row:      {}
};

EditableDataTypeFormatter.propTypes = {
    name:     string,
    onChange: func,
    row:      shape({
        id: string
    })
};

export default EditableDataTypeFormatter;
